import { render, staticRenderFns } from "./AndroidIcon.vue?vue&type=template&id=56985257&"
import script from "./AndroidIcon.vue?vue&type=script&lang=js&"
export * from "./AndroidIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports